"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDataContext = exports.UserDataProvider = void 0;
var react_1 = __importDefault(require("react"));
var services_1 = require("../../services");
var analytics = __importStar(require("../../shared/helpers/analytics"));
var brand_provider_1 = require("../brand/brand.provider");
var config_provider_1 = require("../config/config.provider");
var enums_1 = require("../../shared/enums");
var UserDataContext = react_1.default.createContext({});
exports.UserDataContext = UserDataContext;
function UserDataProvider(props) {
    var context = react_1.default.useContext(config_provider_1.ConfigContext);
    var brandState = react_1.default.useContext(brand_provider_1.BrandContext);
    var _a = react_1.default.useState(props.state || {}), state = _a[0], setState = _a[1];
    react_1.default.useEffect(function () {
        function fetchUser() {
            return __awaiter(this, void 0, void 0, function () {
                var otkIdentityService, otkUser;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!context) return [3 /*break*/, 3];
                            otkIdentityService = new services_1.OtkIdentityService(context.service);
                            if (!otkIdentityService.authService.userId) return [3 /*break*/, 2];
                            return [4 /*yield*/, otkIdentityService.getUser(otkIdentityService.authService.userId)];
                        case 1:
                            otkUser = _a.sent();
                            setState(otkUser);
                            _a.label = 2;
                        case 2: return [3 /*break*/, 4];
                        case 3:
                            console.error("Must be inside 'ConfigProvider'");
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        fetchUser();
    }, [context]);
    react_1.default.useEffect(function () {
        if ((brandState === null || brandState === void 0 ? void 0 : brandState.brand) && (state === null || state === void 0 ? void 0 : state.guid)) {
            var brand = brandState === null || brandState === void 0 ? void 0 : brandState.brand.toLowerCase();
            analytics.initialize({
                account: {
                    id: state.schoolGuid,
                },
                visitor: {
                    id: state.guid,
                    brand: brand.charAt(0).toUpperCase() + brand.slice(1),
                    school_id: state.schoolGuid,
                    user_type: state.role === enums_1.IdentityRolesEnum.TEACHER ? 'customer' : state.role,
                },
            });
        }
    }, [brandState, state]);
    return react_1.default.createElement(UserDataContext.Provider, { value: state }, props.children);
}
exports.UserDataProvider = UserDataProvider;
